// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"216bc93965df030a","4173":"d386f7d3d3929191","5546":"492fd9e3823bfffa","6975":"88858ebb1914c5a3"}[chunkId] + ".css";
};